import { axiosInstance } from "@/lib/axios"
import { EmailTemplate } from "./emailService"

export interface UpdateTemplateParams {
  subject: string
  title: string
  content: string
  imageUrl?: string | null
  buttonText?: string | null
  buttonUrl?: string | null
  isActive?: boolean
}

export interface PreviewResponse {
  html: string
  template: EmailTemplate
}

class EmailTemplateService {
  // Tüm şablonları getir
  async getAll() {
    return axiosInstance.get<{ status: string; data: EmailTemplate[] }>("/email-templates")
  }

  // Tek bir şablonu getir
  async getBySlug(slug: string) {
    return axiosInstance.get<{ status: string; data: EmailTemplate }>(`/email-templates/${slug}`)
  }

  // Şablonu güncelle
  async update(slug: string, params: UpdateTemplateParams) {
    return axiosInstance.put<{ status: string; message: string; data: EmailTemplate }>(
      `/email-templates/${slug}`,
      params
    )
  }

  // Şablonu aktif/pasif yap
  async toggle(slug: string) {
    return axiosInstance.patch<{ status: string; message: string; data: EmailTemplate }>(
      `/email-templates/${slug}/toggle`
    )
  }

  // Şablon önizleme
  async preview(slug: string) {
    return axiosInstance.post<{ status: string; data: PreviewResponse }>(
      `/email-templates/${slug}/preview`
    )
  }
}

export const emailTemplateService = new EmailTemplateService()
